import { ContractPackChannel } from '@core/models/contract-pack-channel/contract-pack-channel.model';

export interface JsonContractPack {
  id: number;
  label: string;
  year: number;
  isActive?: number;
  updatedAt?: Date;
  defTx: number;
  contractPackChannels: ContractPackChannel[];
}

export class ContractPack {
  id: number;
  label: string;
  year: number;
  isActive?: number;
  updatedAt?: Date;
  defTx?: number;
  contractPackChannels: ContractPackChannel[];

  constructor(jsonContractPack: JsonContractPack = null) {
    this.id = jsonContractPack.id;
    this.label = jsonContractPack.label;
    this.year = jsonContractPack.year;
    this.isActive = jsonContractPack.isActive;
    this.updatedAt = jsonContractPack.updatedAt;
    this.defTx = jsonContractPack.defTx;
    this.contractPackChannels = jsonContractPack.contractPackChannels;
  }
}
